import { DepositStatement } from "@/modules/deposit/components";

export const DepositStatementPage = () => {

  return (
    <div className="full-width page-container">
      <DepositStatement/>
    </div>
  );
};
